import { useUserQuery } from "../common/lib/fetch";
import { QueryOptions } from "../common/lib/fetch/useQuery";
import { useUser } from "../userAccess/useUser";

export type SiteUserDto = {
  id: string;
  email: string;
  role: 'Admin' | 'LimitedAccess';
}

export const useGetSiteUsers = (options?: QueryOptions<SiteUserDto[]>) => {
  const user = useUser();

  return useUserQuery<SiteUserDto[]>({
    path: `/api/sites/${user.selectedSite?.id}/users`,
  }, options);
}
